import DateFnsUtils from '@date-io/date-fns'
import { getLocale, getLocaleFns } from 'localization/get-locale'

const dateFns = new DateFnsUtils({ locale: getLocaleFns(getLocale()) })

const format: typeof dateFns['format'] = (date, formatStr) =>
  dateFns.format(date, formatStr)

export default format
